import { createFileRoute } from '@tanstack/react-router';
import { CampaignShapePickerPage } from '@/features/marketing';

/**
 * `campaigns_` keeps the create screens out of the list route's nesting. New campaign opens on the shape picker
 * ("What do guests get?"); its cards lead to `new/voucher`, `new/event` or the New Client Offer.
 */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/new')({
  component: NewCampaignRoute,
});

function NewCampaignRoute() {
  const { orgId } = Route.useParams();
  return <CampaignShapePickerPage orgId={orgId} />;
}
